import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './components/Dashboard'

const App = () => (
  <div>
    <Dashboard />
  </div>
);

export default App;
